import React, { FC } from 'react';
import styles from './InfoProgressPrice.module.scss';
import classNames from 'classnames';
import { addSpaceNumber } from 'utils/addSpaceNumber';
import ContentLoader from 'react-content-loader';

interface buttonType {
  orders: string;
  taxes: string;
  disabled: string;
}

const themes: buttonType = {
  orders: styles.orders,
  taxes: styles.taxes,
  disabled: styles.dis,
};

interface InfoProgressPriceTypes {
  color?: keyof typeof themes;
  price: number;
  text: string;
  loading?: boolean;
}

export const InfoProgressPrice: FC<InfoProgressPriceTypes> = ({
  color,
  text,
  price = 0,
  loading = false,
}) => {
  return (
    <div className={styles.root}>
      {color ? <div className={classNames(styles.root_range, themes[color])} /> : null}
      <div className={styles.root_blockText}>
        <span>{text}</span>
        {loading ? (
          <p className={styles.price}>
            <span className={styles.price_placeholder}>{addSpaceNumber(price)} ₽</span>
            <ContentLoader
              speed={2}
              height={18}
              className={styles.price_skeleton}
              backgroundColor={'#FFFFFF'}
              foregroundColor={'#D8E4FB8C'}>
              <rect x='0' y='0' rx='0' ry='0' width='100%' height='100%' />
            </ContentLoader>
          </p>
        ) : (
          <p>{addSpaceNumber(price)} ₽</p>
        )}
      </div>
    </div>
  );
};
